module.exports = __webpack_public_path__ + "cover-letter-47f61a13/template-7-preview-d132bb2d8dc18513da52a98cbe052aa0.jpg";